import { motion } from "motion/react";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";
import WhatsAppFloating from "../../../components/feature/WhatsAppFloating";
import CookieBanner from "../../../components/feature/CookieBanner";
import QuoteFormSection from "../../../pages/home/components/QuoteFormSection";
import SEO from "@/components/feature/SEO";

const reparamos = [
  { emoji: "🔧", title: "Telas rotas o rasgadas", desc: "La fibra se deshilacha con el tiempo o se rompe por arañazos. Cambiamos la tela entera sin tocar el marco." },
  { emoji: "🕳️", title: "Telas con agujeros", desc: "Agujeros pequeños que dejan pasar mosquitos. Reparamos parches en telas gruesas o cambiamos la tela completa si es fina." },
  { emoji: "📐", title: "Marcos descuadrados", desc: "El marco se ha deformado por golpes o instalación incorrecta. Lo enderezamos o sustituimos para que cierre bien." },
  { emoji: "🌀", title: "Sistemas enrollables atascados", desc: "El muelle no recoge, el freno está roto o la tela se ha salido de las guías. Lo desmontamos, limpiamos y ajustamos." },
  { emoji: "⏱️", title: "Frenos desgastados", desc: "La mosquitera baja sola o no se queda abajo. Sustituimos el freno interno por uno nuevo." },
];

const cambioTela = {
  title: "Cambio de tela",
  desc: "El trabajo más frecuente. Desmontamos la mosquitera, retiramos la tela vieja, instalamos la nueva y la ajustamos al marco. En la mayoría de los casos lo hacemos en tu casa en menos de 30 minutos por unidad.",
  precio: "35-50 €",
};

const marcos = {
  title: "Marcos",
  desc: "Si el marco está descuadrado, doblado o roto en las esquinas, lo enderezamos o sustituimos. También reponemos pestillos, imanes y bisagras rotas.",
  precio: "40-80 €",
};

const sistemas = {
  title: "Sistemas enrollables",
  desc: "Reparamos muelles rotos, frenos desgastados, recogedores atascados y guías desalineadas. En algunos casos es más económico sustituir el cassette completo.",
  precio: "50-120 €",
};

const precios = [
  { servicio: "Cambio de tela estándar", precio: "35-50 €" },
  { servicio: "Cambio de tela anti-polen", precio: "45-60 €" },
  { servicio: "Ajuste marco descuadrado", precio: "40-80 €" },
  { servicio: "Reparación sistema enrollable", precio: "50-120 €" },
  { servicio: "Sustitución cierre magnético", precio: "20-35 €" },
];

const mantenimiento = [
  "Limpia la tela con agua y jabón neutro cada 3-6 meses.",
  "No uses productos químicos agresivos ni amoniaco: debilitan la fibra.",
  "Comprueba los pestillos y cierres: si están flojos, apriétalos.",
  "Enrollables: no tires de la tela bruscamente, baja suavemente.",
  "Retira las hojas y suciedad acumuladas en los raíles de las correderas.",
];

const faqs = [
  { q: "¿Reparáis mosquiteras de cualquier marca?", a: "Sí, reparamos mosquiteras de todas las marcas y fabricantes. Si no encontramos recambio exacto, adaptamos uno compatible." },
  { q: "¿Cuánto tarda la reparación?", a: "El cambio de tela dura unos 20-30 minutos por unidad. Reparaciones de sistema enrollable pueden llevar hasta 1 hora. Si necesitamos pedir piezas, tardamos 24-48h." },
  { q: "¿Tenéis recambios en stock?", a: "Sí, llevamos telas de fibra de vidrio, poliéster y anti-polen en varios colores. También marcos, muelles, frenos y cierres." },
  { q: "¿Da garantía la reparación?", a: "Sí, 1 año en el cambio de tela y 2 años en reparaciones de sistema. Si falla por defecto de la pieza, la cambiamos gratis." },
  { q: "¿Trabajáis con comunidades de vecinos?", a: "Sí, reparamos mosquiteras en bloques de pisos, urbanizaciones y hoteles. Ofrecemos descuentos por volumen." },
];

export default function ReparacionMosquiteras() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Reparación Mosquiteras Málaga | Cambio Tela y Marco"
        description="Reparamos mosquiteras en Málaga: cambio de tela rota, marcos descuadrados, sistemas enrollables. Desde 35€. Presupuesto gratis. ☎ 951 12 07 70"
        canonical="/mosquiteras/reparacion-mosquiteras/"
        breadcrumbs={[{ name: "Inicio", path: "/" }, { name: "Mosquiteras", path: "/mosquiteras" }, { name: "Reparación mosquiteras" }]}
      />
      <Header />
      <main>
        {/* HERO */}
        <section className="bg-white pt-24 md:pt-[72px]">
          <div className="max-w-container mx-auto px-4 md:px-6 py-12 md:py-24">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="w-full lg:w-[55%] flex flex-col gap-6">
                <div className="inline-flex items-center gap-2 bg-accent text-text-primary font-body font-semibold text-sm px-4 py-2 rounded-pill w-fit">
                  <span>⚡</span> Desde 35€
                </div>
                <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-[56px] leading-[1.1] text-text-primary">
                  Reparación de Mosquiteras en Málaga
                </h1>
                <p className="font-body text-lg md:text-xl text-text-secondary leading-relaxed max-w-xl">
                  Cambiamos telas rotas, ajustamos marcos descuadrados, reparamos sistemas enrollables. Servicio rápido y económico.
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                  <a
                    href="tel:+34951120770"
                    className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg md:text-xl px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
                  >
                    <span>📞</span> 951 12 07 70
                  </a>
                  <a
                    href="#presupuesto"
                    className="inline-flex items-center gap-2 border-2 border-secondary text-secondary hover:bg-secondary hover:text-white font-body font-semibold text-base px-6 py-3.5 rounded-pill transition-colors whitespace-nowrap"
                  >
                    Pedir presupuesto
                  </a>
                </div>
                <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-2">
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Desde 35€</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Recambios en stock</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Garantía 1 año</span>
                </div>
              </div>
              <div className="w-full lg:w-[45%] relative">
                <div className="relative rounded-3xl overflow-hidden lg:rotate-1 shadow-xl">
                  <div className="absolute inset-0 bg-blue-900/35 z-10 pointer-events-none"></div>
                  <img
                    src="https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1200&q=80&auto=format&fit=crop"
                    alt="Reparación de mosquiteras en Málaga"
                    className="w-full h-auto object-cover aspect-[4/3]"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ¿QUÉ REPARAMOS? */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">¿Qué reparamos?</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {reparamos.map((r, i) => (
                <motion.div
                  key={r.title}
                  className="bg-white rounded-[20px] p-8 shadow-sm hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="text-3xl mb-3">{r.emoji}</div>
                  <h3 className="font-heading font-bold text-lg text-text-primary mb-2">{r.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{r.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* SERVICIOS DETALLE */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <motion.div
                className="bg-surface-alt rounded-[20px] p-8 shadow-sm hover:shadow-md transition-shadow"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0 }}
              >
                <h3 className="font-heading font-bold text-xl text-text-primary mb-3">{cambioTela.title}</h3>
                <p className="font-body text-sm text-text-secondary leading-relaxed mb-4">{cambioTela.desc}</p>
                <div className="font-heading font-bold text-2xl text-primary">{cambioTela.precio}</div>
              </motion.div>
              <motion.div
                className="bg-surface-alt rounded-[20px] p-8 shadow-sm hover:shadow-md transition-shadow"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                <h3 className="font-heading font-bold text-xl text-text-primary mb-3">{marcos.title}</h3>
                <p className="font-body text-sm text-text-secondary leading-relaxed mb-4">{marcos.desc}</p>
                <div className="font-heading font-bold text-2xl text-primary">{marcos.precio}</div>
              </motion.div>
              <motion.div
                className="bg-surface-alt rounded-[20px] p-8 shadow-sm hover:shadow-md transition-shadow"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <h3 className="font-heading font-bold text-xl text-text-primary mb-3">{sistemas.title}</h3>
                <p className="font-body text-sm text-text-secondary leading-relaxed mb-4">{sistemas.desc}</p>
                <div className="font-heading font-bold text-2xl text-primary">{sistemas.precio}</div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* TABLA PRECIOS */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Precios de reparación</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="max-w-2xl mx-auto bg-white rounded-3xl overflow-hidden shadow-sm">
              {precios.map((p, i) => (
                <div
                  key={p.servicio}
                  className={`flex items-center justify-between px-6 md:px-8 py-5 ${i !== precios.length - 1 ? "border-b border-border" : ""}`}
                >
                  <span className="font-body text-base md:text-lg text-text-primary">{p.servicio}</span>
                  <span className="font-heading font-bold text-lg md:text-xl text-primary">{p.precio}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* MANTENIMIENTO DIY */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Mantenimiento básico DIY</h2>
                <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
                <p className="font-body text-lg text-text-secondary mt-4">
                  Con estos cuidados simples alargarás la vida de tu mosquitera varios años.
                </p>
              </div>
              <div className="bg-surface-alt rounded-[20px] p-8 md:p-10 shadow-sm">
                <ul className="flex flex-col gap-4">
                  {mantenimiento.map((m, i) => (
                    <li key={i} className="flex items-start gap-3 font-body text-sm md:text-base text-text-secondary">
                      <span className="shrink-0 w-6 h-6 bg-secondary/10 text-secondary rounded-full flex items-center justify-center font-bold text-xs mt-0.5">{i + 1}</span>
                      {m}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Preguntas frecuentes</h2>
                <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
              </div>
              <div className="space-y-4" itemScope itemType="https://schema.org/FAQPage">
                {faqs.map((f, i) => (
                  <motion.div
                    key={i}
                    className="bg-white rounded-2xl p-6 md:p-8"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.05 }}
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                  >
                    <h3 className="font-heading font-bold text-lg text-text-primary mb-2" itemProp="name">{f.q}</h3>
                    <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                      <p className="font-body text-sm text-text-secondary leading-relaxed" itemProp="text">{f.a}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-text-primary py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-white mb-4">
              ¿Tu mosquitera está rota?
            </h2>
            <p className="font-body text-lg text-slate-300 mb-8 max-w-2xl mx-auto">
              Cambiamos la tela desde 35€. Te visitamos rápido y reparamos en el acto si llevamos recambios.
            </p>
            <a
              href="tel:+34951120770"
              className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg px-8 py-4 rounded-pill transition-colors"
            >
              <span>📞</span> Llámanos: 951 12 07 70
            </a>
          </div>
        </section>

        {/* FORM */}
        <div id="presupuesto">
          <QuoteFormSection />
        </div>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}